import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedAccessorySelector($companyId: ID!, $id: ID) {
    assetTypes(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        images { id url }
      }
    }
    rowItems(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        images { id url }
      }
    }
  }
`

export const Query = gql`
  query AccessorySelector(
    $companyId: ID!,
    $assetTypeFilters: AssetTypeFilters,
    $rowItemFilters: RowItemFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    companies(filters: { idEq: $companyId }) {
      nodes {
        id
        placeholderLogo { id url }
      }
    }
    assetTypes(
      companyId: $companyId,
      filters: $assetTypeFilters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
        images { id url }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
    rowItems(
      companyId: $companyId,
      filters: $rowItemFilters,
      after: $after,
      before: $before,
      first: $first,
      last: $last
    ) {
      nodes {
        id
        name
        images { id url }
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
